import React, { useState } from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import emptyIcon from "../../../assets/images/Icons/search-table.png";
import { formatWeightWithUnits } from "../../../utils";
import BatchProductList from "../../ProductionChart/components/BatchProductList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BatchIngredientList from "../../ProductionChart/components/BatchIngredientList";

export const BatchesView = (props) => {
  const { selectedOptionBatch, templates, globalData } = props;

  // Select the current batch from the filtered list
  const currentBatch = selectedOptionBatch;

  const IngredientItem = ({ item, level = 0 }) => {
    const [expanded, setExpanded] = useState(false);
    const hasSubItems = item.type === "recipe";
    const isMainIngredient = item?.pivot?.is_main_ingredient; // Assuming this flag exists in your data
    const handleExpand = () => {
      setExpanded(!expanded);
    };

    return (
      <Box
        sx={{
          backgroundColor: level === 0 ? "#F8FAFC" : "transparent",
          borderRadius: level === 0 ? "6px" : "none",
          padding: level === 0 ? "8px 12px" : "6px 16px",
          marginY: level === 0 ? "4px" : "0px",
          border: level === 0 ? "1px solid #E0E0E0" : "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: `${level * 20}px`,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: level === 0 ? 600 : 400 }}
            >
              {item?.name}
            </Typography>
            {hasSubItems && (
              <IconButton size="small" onClick={handleExpand}>
                <ExpandMoreIcon
                  sx={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s",
                  }}
                />
              </IconButton>
            )}
            {isMainIngredient ? (
              <StarIcon sx={{ color: "#1760D2", fontSize: 18 }} /> // Star icon for main ingredients
            ) : null}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography fontWeight={600} fontSize={"14px"}>
              {formatWeightWithUnits(
                item.pivot.base_unit_qty,
                item.pivot.base_unit_symbol,
                globalData?.all_Units
              )}
            </Typography>
          </Box>
        </Box>

        {hasSubItems && expanded && (
          <Box>
            {item.ingredient.map((subItem, index) => (
              <IngredientItem key={index} item={subItem} level={level + 1} />
            ))}
          </Box>
        )}
      </Box>
    );
  };

  return (
    <>
      {selectedOptionBatch?.ingredients?.length ? (
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            width: "100%",
            height: "calc(100dvh - 145px)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              minWidth: { lg: "345px" },
              flexGrow: 345,
              flex: 1,
              px: "12px",
              gap: "12px",
              pb: "12px",
              borderRight: { sm: 1 },
              borderColor: { sm: "divider" },
              height: "calc(100dvh - 145px)",
              overflowY: "auto",
            }}
          >
            <Box pt="16px">
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                }}
              >
                Batch is for
              </Typography>
            </Box>
            <BatchProductList
              products={selectedOptionBatch?.products ?? []}
              globalData={globalData}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              px: "12px",
              gap: "12px",
              flex: 2,
              pb: "12px",
              height: "calc(100dvh - 145px)",
              overflowY: "auto",
            }}
          >
            <Box pt="16px">
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                }}
              >
                Ingredients
              </Typography>
            </Box>

            <BatchIngredientList
              currentBatch={currentBatch}
              selectedStore={selectedOptionBatch}
              batchIndex={templates.indexColumn}
              globalData={globalData}
            />
          </Box>
        </Stack>
      ) : (
        <Stack
          sx={{
            flex: 1,
            flexShrink: 1,
            height: "calc(100dvh - 145px)",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={emptyIcon} alt="empty" height={56} width={56} />
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              color: "#485364",
              width: "500px",
            }}
          >
            There are no products or ingredients yet!. You need to create batch
            first.
          </Typography>
        </Stack>
      )}
    </>
  );
};
